export default __webpack_public_path__ + "static/media/left.00a14e66.svg";